"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var react_dom_1 = require("react-dom");
function createWrapper(id) {
    var element = document.createElement('div');
    element.setAttribute('id', id);
    element.classList.add('hst-portal');
    document.body.appendChild(element);
    return element;
}
var Portal = function (_a) {
    var children = _a.children, target = _a.target;
    var _b = tslib_1.__read(React.useState(function () {
        return typeof target !== 'string' ? target : null;
    }), 2), wrapperElement = _b[0], setWrapperElement = _b[1];
    React.useLayoutEffect(function () {
        if (typeof target !== 'string') {
            return;
        }
        var element = document.getElementById(target);
        var created = false;
        if (!element) {
            created = true;
            element = createWrapper(target);
        }
        setWrapperElement(element);
        return function () {
            if (created && (element === null || element === void 0 ? void 0 : element.parentNode)) {
                element.parentNode.removeChild(element);
            }
        };
    }, [target]);
    if (!wrapperElement)
        return null;
    return (0, react_dom_1.createPortal)(children, wrapperElement);
};
exports.default = Portal;
